import {
  ArrowBigDownDashIcon,
  BarChart3,
  Building2,
  ChevronLeft,
  ChevronRight,
  CircleUser,
  Eye,
  Globe,
  Home,
  Linkedin,
  LockKeyhole,
  PackageCheck,
  Star,
  Target,
  User,
} from "lucide-react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Grid } from "../../ui/Grid";
import { motion } from "framer-motion";
import { user6 } from "../../../assets";
import {
  scrollVariantsLeft,
  scrollVariantsRight,
} from "../../../constants/TextAnimation";

const About = () => {
  const navigate = useNavigate();
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1,
    );
  };

  // Auto-switch effect
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  // const teamMembers = [
  //   {
  //     name: "Sarah Chen",
  //     title: "Founder & CEO",
  //     bio: "With over 20 years in international real estate, Sarah founded Scan Global Realty to bridge cultural and market gaps in global property investment.",
  //     imageUrl:
  //       "https://images.pexels.com/photos/5704720/pexels-photo-5704720.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   },
  //   {
  //     name: "Michael Rodriguez",
  //     title: "Chief Operations Officer",
  //     bio: "Michael brings 15 years of operational excellence from luxury real estate markets across Europe and North America.",
  //     imageUrl:
  //       "https://images.pexels.com/photos/5397723/pexels-photo-5397723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   },
  //   {
  //     name: "Aisha Patel",
  //     title: "Global Markets Director",
  //     bio: "Specializing in emerging markets, Aisha has facilitated over $500M in international property transactions in the past decade.",
  //     imageUrl:
  //       "https://images.pexels.com/photos/6000065/pexels-photo-6000065.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   },
  //   {
  //     name: "David Kwon",
  //     title: "Technology Officer",
  //     bio: "David leads our technological innovation, creating proprietary systems that connect clients with global opportunities in real time.",
  //     imageUrl:
  //       "https://images.pexels.com/photos/2379005/pexels-photo-2379005.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  //   },
  // ];

  const benefits = [
    {
      icon: <Globe className="w-6 h-6 text-gold" />,
      title: "Specialized Expertise",
      description:
        "Our team specializes in the real estate markets of Dubai. We stay ahead of market trends, enabling you to capitalize on emerging opportunities.",
    },
    {
      icon: <PackageCheck className="w-6 h-6 text-gold" />,
      title: "Diverse Portfolio",
      description:
        "Our portfolio showcases a wide range of properties, from luxurious residences to high-yield investment properties, ensuring there is something for every investor.",
    },
    {
      icon: <BarChart3 className="w-6 h-6 text-gold" />,
      title: "Growth Oriented",
      description:
        "We not only help you in the moment but we focus on your growth in your investing journey, we make sure you have a long term plan when it comes to your real estate venture.",
    },
    {
      icon: <LockKeyhole className="w-6 h-6 text-gold" />,
      title: "Dedicated Team",
      description:
        "Our team is dedicated to make sure you are in the best position possible when making your decisions. The dream team is ready to serve!",
    },
  ];
  const testimonials = [
    // {
    //   name: "Summer Assaf",
    //   role: "Head Client Engagement",
    //   quote:
    //     "Scan Global Realty helped me acquire three commercial properties across different countries. Their team's knowledge of local regulations saved me countless hours and potentially costly mistakes.",
    //   // location: "London, UK",
    //   rating: 5,
    //   imageUrl: "/images/users/user7.jpg",
    // },
    {
      name: "Rabia Sajid",
      role: "Senior Investment Consultant",
      quote:
        "When relocating my family internationally, Scan Global made what could have been a stressful process incredibly smooth. Their attention to our specific needs was impressive.",
      // location: "Madrid, Spain",
      rating: 5,
      imageUrl: "/images/users/user5.jpg",
    },
    {
      name: "Thasmina Fathima",
      role: "Admin Executive",
      quote:
        "The market intelligence provided by Scan Global Realty has been instrumental in our expansion strategy. Their forecasting and analysis are consistently accurate and valuable.",
      // location: "Tokyo, Japan",
      rating: 5,
      imageUrl: "/images/users/user2.jpg",
    },
  ];
  const array = [
    {
      name: "Shelly Howe",
      title: "Broker - Canada",
      image: "3",
      linkedin: "https://www.linkedin.com/in/shellyhowe/",
      phone: "",
      message: "",
    },
    {
      name: "Rabia Sajid",
      title: "Senior Investment Consultant",
      image: "user5",
      linkedin: "https://www.linkedin.com/in/rabia-sajid-5354b3214",
      phone: "",
      message: "",
    },
    {
      name: "Jennifer Harding",
      // title: "Operations & Marketing Manager",
      title: "Creative Director",
      image: "Jennifer",
      // linkedin: "https://www.linkedin.com/in/shellyhowe/",
      phone: "",
      message: "",
    },
    {
      name: "Huzaifa Ghori",
      title: "Business and Growth Strategist",
      image: "HuzaifaGhori",
      phone: "",
      message: "",
    },

    {
      name: "Nikola Blair",
      title: "Head of Strategic Partnerships & Communication (UK)",
      image: "Nikola",
      phone: "",
      message: "",
    },
    {
      name: "Lysann Abi Nader",
      title: "Senior Investment Consultant",
      image: "Lysann",
      // linkedin: "https://www.linkedin.com/in/maricel-gonzalvo9123",
      phone: "",
      message: "",
    },
    {
      name: "Jamel Cooper",
      title: "New York Property Consultant",
      image: "Jamel",
      // linkedin: "https://www.linkedin.com/in/shellyhowe/",
      phone: "",
      message: "",
    },
    {
      name: "Marilyn Miller",
      title: "New York Property Consultant",
      image: "Marilyn",
      // linkedin: "https://www.linkedin.com/in/shellyhowe/",
      phone: "",
      message: "",
    },

    {
      name: "Maricel Golzalvo",
      title: "Senior Investment Consultant",
      image: "maricel",
      linkedin: "https://www.linkedin.com/in/maricel-gonzalvo9123",
      phone: "",
      message: "",
    },

    {
      name: "Thasmina Siddiq",
      title: "Admin Services",
      image: "user2",
      linkedin: "https://www.linkedin.com/in/thasmina-fathima-25634b236/",
      phone: "",
      message: "",
    },

    {
      name: "Bhuvan Zambad",
      title: "Investment Consultant",
      image: "bhuvan",
      linkedin: "",
      phone: "",
      message: "",
    },
    // {
    //   name: "Aqsa Mirza",
    //   title: "Property Consultant",
    //   image: "Aqsamirza",
    //   // linkedin: "https://www.linkedin.com/in/maricel-gonzalvo9123",
    //   phone: "",
    //   message: "",
    // },
    // {
    //   name: "Erick Mongare",
    //   title: "Marketing Executive",
    //   image: "Erick",
    //   linkedin: "https://www.linkedin.com/in/erick-mongare-69b0b537",
    //   phone: "",
    //   message: "",
    // },
  ];

  return (
    <>
      <section className="relative h-[70vh] md:h-[85vh] flex items-center justify-center overflow-hidden bg-gradient-to-r from-gold/10 to-black text-white py-10 sm:py-16 lg:pt-36 lg:pb-24 ">
        <div
          className="absolute inset-0 bg-cover bg-center z-0"
          style={{
            backgroundImage: 'url("/images/realty/14.jpg")',
            backgroundAttachment: "fixed",
            backgroundSize: "cover",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-70"></div>
        </div>
        <div className="relative z-10 text-center px-4 md:px-10 animate-fade-in mt-14 lg:mt-0">
          <Building2 className="md:w-16 md:h-16 w-12 h-12 text-white mx-auto mb-6" />
          <h1 className="text-3xl md:text-6xl font-bold mb-4">
            Real Estate Investment Firm
          </h1>
          <p className="text-lg md:text-xl text-gray-200 max-w-2xl mx-auto">
            Let Scan Global Realty take the lead in your investment journey. We
            help and guide our clients from start to finish throughout their
            investment venture!
          </p>
        </div>
      </section>

      {/* our story */}
      <section className="py-10 md:py-12 overflow-x-hidden">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold  mb-8 text-center text-gold">
              Our Story
            </h2>

            <div className="space-y-8">
              <div className="">
                <p className="text-gray-300 leading-relaxed mb-6">
                  Founded in 2016, Scan Global Holdings Ltd. (SGH) was
                  established in Canada with a vision to redefine how businesses
                  and investors navigate an evolving global economy. From the
                  outset, SGH has embodied innovation, integrity, and foresight
                  delivering bespoke advisory solutions across finance,
                  strategy, and real estate that foster growth, diversity, and
                  forward-thinking leadership worldwide.
                </p>

                <p className="text-gray-300 leading-relaxed mb-6">
                  As global markets evolved, SGH adapted, transforming insight
                  into opportunity. This evolution led to the creation of Scan
                  Global Realty (SGR) in 2023, a natural extension of our
                  international perspective into the property sector. SGR
                  emerged as a dynamic real estate investment brand built on the
                  same principles that define our group: expertise,
                  transparency, and an unwavering commitment to creating
                  long-term value while prioritizing our clients’ best
                  interests.
                </p>

                <p className="text-gray-300 leading-relaxed mb-6">
                  Under the leadership of CEO Wahaj Ahmed, Scan Global Realty
                  continues to expand across continents, blending financial
                  intelligence with real-world market expertise. Together, SGH
                  and SGR are shaping the future of global investment bridging
                  industries, building trust, and delivering excellence at every
                  stage of growth.
                </p>
              </div>

              <div className="">
                <h3 className="text-2xl font-semibold  mb-4">Our Journey</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8">
                  <div className="bg-slate-900/60 p-6 rounded-lg shadow-sm flex-1">
                    <span className="text-gold font-bold text-xl">
                      2016 – Founding Vision{" "}
                    </span>
                    <p className="mt-2 text-gray-400">
                      Scan Global Holdings Ltd. was incorporated in Canada with
                      a mission to provide integrated financial and business
                      advisory solutions across multiple industries. The company
                      began as a strategic partner for entrepreneurs, investors,
                      and corporations seeking intelligent pathways to growth.
                    </p>
                  </div>
                  <div className="bg-slate-900/60 p-6 rounded-lg shadow-sm flex-1">
                    <span className="text-gold font-bold text-xl">
                      2020 – Global Reset & Strategic Reinvention
                    </span>
                    <p className="mt-2 text-gray-400">
                      In response to the unprecedented global disruption of
                      2020, the company entered a reflective pause and a
                      strategic recalibration. This pivotal year marked a shift
                      in direction: identifying emerging market opportunities,
                      adapting to new economic realities, and refining our
                      investment philosophy to align with a rapidly changing
                      world.
                    </p>
                  </div>
                  <div className="bg-slate-900/60 p-6 rounded-lg shadow-sm flex-1">
                    <span className="text-gold font-bold text-xl">
                      2023 – Expansion into the Middle East
                    </span>
                    <p className="mt-2 text-gray-400">
                      In 2023, Scan Global Holdings expanded into the Middle
                      East with the launch of Scan Global Realty (SGR) and Scan
                      Global Solutions (SGS) in Dubai. This milestone marked the
                      group’s entry into a dynamic market, connecting global
                      investors to exclusive real estate opportunities and
                      positioning property as a cornerstone of diversified
                      wealth.
                    </p>
                  </div>

                  <div className="bg-slate-900/60 p-6 rounded-lg shadow-sm flex-1">
                    <span className="text-gold font-bold text-xl">
                      2025 – Global Expansion
                    </span>
                    <p className="mt-2 text-gray-400">
                      With a strong foundation and proven track record, Scan
                      Global Holdings continues its international growth,
                      expanding its footprint across the United Kingdom and the
                      United States, while deepening its network of global
                      partnerships and investment platforms.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* mission and vision */}
      <section className="py-2 md:py-12  overflow-x-hidden">
        <div className="container mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-10 text-center">
            Mission & Vision
          </h2>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            <div className="bg-slate-900/60 rounded-xl shadow-md p-8">
              <div className="flex items-center mb-6">
                <div className="bg-gold p-3 rounded-full mr-4">
                  <Target className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold">
                  Your Path to Smart Investing
                </h3>
              </div>
              <p className="text-gray-400 leading-relaxed">
                Our mission is to have you set with a long term plan, let us
                help you step into the market with the right knowledge and
                execution to make your investment work for you!
              </p>
            </div>

            <div className="bg-slate-900/60 rounded-xl shadow-md p-8">
              <div className="flex items-center mb-6">
                <div className="bg-secondary p-3 rounded-full mr-4">
                  <Eye className="h-8 w-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold">Our Vision</h3>
              </div>
              <p className="text-gray-400 leading-relaxed">
                To be the world's most trusted global real estate partner, known
                for our unparalleled market intelligence, cultural sensitivity,
                and client-focused approach. We envision a future where borders
                don't limit property opportunity, and every transaction creates
                lasting value.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* team */}
      {/* <section className="py-16 md:py-24 ">
        <div className="container mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-6 text-center">
            Meet the Team
          </h2>
          <p className="text-gray-400 max-w-3xl mx-auto text-center mb-16">
            Our diverse team of experts combines local knowledge with global
            perspective to deliver exceptional results for our clients.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {teamMembers.map((member, index) => (
              <div
                key={index}
                className="bg-gray-800/50 rounded-xl overflow-hidden shadow-md transition-all duration-300 hover:shadow-lg group"
              >
                <div className="h-64 overflow-hidden">
                  <img
                    src={member.imageUrl}
                    alt={member.name}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="p-6">
                  <div className="flex justify-between items-start">
                    <div>
                      <h3 className="text-xl font-bold ">{member.name}</h3>
                      <p className="text-gold font-medium">{member.title}</p>
                    </div>
                    <Link
                      href={member.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-secondary hover:secondary transition-colors"
                    >
                      <Linkedin className="w-5 h-5" />
                    </Link>
                  </div>
                  <p className="mt-4 text-gray-600 text-sm">{member.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
      <section className="py-16 md:py-24 overflow-x-hidden">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center">
            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={scrollVariantsRight}
              viewport={{ amount: 0.3 }}
              className="relative w-full md:w-5/12 px-4 mr-auto ml-auto mb-8 md:mb-0"
            >
              {/* Top-left gradient square */}
              <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-br from-gold/40 to-secondary/20 rounded-md -translate-x-4 -translate-y-4 z-[-1]" />

              {/* Bottom-right gradient square */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-tr from-gold/40 to-secondary/20 rounded-md translate-x-4 translate-y-4 z-[-1]" />

              <img
                alt="Cloud Computing Infrastructure"
                src="/images/realty/6.jpg"
                className="w-full rounded-lg shadow-lg"
              />
            </motion.div>

            <motion.div
              initial="hidden"
              whileInView="visible"
              variants={scrollVariantsLeft}
              viewport={{ amount: 0.3 }}
              className="w-full md:w-5/12 px-4 my-auto mr-auto ml-auto space-y-4"
            >
              <div className="inline-flex gap-2 px-4 py-2 rounded-full bg-gold/10">
                <User size={20} className="text-gold" />
                our mission
              </div>
              <h3 className="text-xl md:text-5xl font-semibold mb-5">
                Your Path to Smart Investing
              </h3>
              <p className="text-gray-400">
                Our mission is to have you set with a long term plan, let us
                help you step into the market with the right knowledge and
                execution to make your investment work for you!
              </p>
              <div className="text-cente mt-5">
                <button
                  className="bg-gradient font-medium px-6 py-2 border rounded-lg border-slate-400"
                  onClick={() => navigate("/realty/contact")}
                >
                  Get Started Now
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* team */}
      <section className="pb-12 md:pb-22">
        <div className="container mx-auto px-4 py-2">
          <div className="text-center max-w-xl mx-auto mb-10 md:mb-16 space-y-2">
            <div className="bg-gold/10 px-4 py-2 rounded-full inline-flex gap-2 items-center">
              <Home size={20} className="text-gold" /> Our team
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-gold">
              Meet our Team
            </h2>
            <p className="text-gray-400 text-lg ">
              Connect with our expert agents, ready to assist you in buying or
              selling with confidence
            </p>
          </div>

          <main className="container mx-auto px-4 py-4">
            <div className="flex flex-col items-center">
              {/* Profile Image Section */}
              <div className="w-full max-w-sm mb-8">
                <div className="relative group overflow-hidden border rounded-2xl shadow-xl">
                  <img
                    src="/images/users/user3.jpg"
                    alt="Wahaj Ahmed Profile"
                    className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute top-0 right-0 w-6 h-6 rounded-full bg-gradient-to-r from-yellow-400 to-amber-600 animate-pulse"></div>
                  <div className="absolute right-0 bottom-0 w-2 bg-gradient-to-b from-yellow-400 to-amber-600 h-16"></div>
                </div>
              </div>

              {/* Content Section */}
              <div className="w-full max-w-2xl bg-white/5 backdrop-blur-sm rounded-xl shadow-lg p-6 sm:p-8">
                {/* Title */}
                <h6 className="text-2xl sm:text-3xl font-extrabold mb-6 text-center relative">
                  Founder and CEO
                  <span className="absolute left-1/2 bottom-[-0.5rem] w-12 h-1 bg-gradient-to-r from-yellow-400 to-amber-600 rounded-full transform -translate-x-1/2"></span>
                </h6>

                {/* Name and Credentials */}
                <div className="text-center mb-6">
                  <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-white">
                    Wahaj Ahmed
                  </h1>
                  <p className="text-sm text-gray-300 inline-flex items-center gap-4 font-medium mt-2">
                    <span>CPA (Canada) | FCCA (UK) I CA (UAE)</span>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="https://www.linkedin.com/in/wahaja/"
                    >
                      <Linkedin
                        // color="#fff"
                        size={30}
                        className="border-white/20 p-1.5 rounded-xl bg-gold hover:bg-opacity-85 transition-all duration-200 text-slate-900 border"
                      />
                    </Link>
                  </p>
                  <p className="text-sm text-gray-400 font-medium">
                    CEO and Founder, Scan Global Holdings
                  </p>
                </div>

                {/* Bio */}
                <div className="mb-8">
                  <div className="flex items-start justify-center">
                    <div className="w-12 h-0.5 bg-yellow-400 mr-4 mt-3"></div>
                    <p className="text-sm sm:text-base text-gray-200 leading-relaxed max-w-lg">
                      “ Bringing 15+ years of experience in controlling all
                      aspects of corporate accounting and financial reporting
                      functions of various Fortune 500 Organizations and Top 10
                      global accounting firms. Wahaj leads with extensive
                      experience in global{" "}
                      <span className="font-semibold text-white">
                        Business Advisory and Real Estate.
                      </span>
                    </p>
                  </div>
                </div>

                {/* Key Points */}
                <div className="space-y-6">
                  {/* [
                    {
                      title: "I Spark Curiosity",
                      desc: "Challenging assumptions to uncover meaningful questions about our beliefs.",
                    },
                    {
                      title: "I Organize Insights",
                      desc: "Structuring doubts into clear, actionable answers.",
                    },
                    {
                      title: "I Study Experiences",
                      desc: "Analyzing the process to drive continuous growth.",
                    },
                  ] */}
                  {[
                    {
                      title: "Discovery & Insight",
                      desc: "Every partnership begins with understanding. Through an in-depth consultation, Wahaj and his team identify the client’s goals, challenges, and long-term vision. This stage focuses on clarity uncovering true needs and opportunities that may lie beyond the surface.",
                    },
                    {
                      title: "Strategic Design & Resource Alignment",
                      desc: "Once clarity is achieved, Team Scan orchestrates the right people, tools, and strategies. This is where innovation meets structure where customized solutions are crafted and aligned to combine core strengths to design bespoke solutions in business growth, and investment strategy.",
                    },
                    {
                      title: "Integration & Growth",
                      desc: "In the final phase, every element comes together. Wahaj and his team ensure execution with precision, building exceptional cross-disciplinary collaboration across Business Brokerage, CFO & Financial Solutions, and Advisory Services and real estate. Clients leave not just with results, but with a holistic strategy for continued expansion.",
                    },
                  ].map((item, index) => (
                    <div
                      key={index}
                      className="relative pl-6 border-l-2 border-gray-600 group hover:border-yellow-400 transition-colors duration-300"
                    >
                      <div className="absolute left-0 top-2 w-3 h-3 bg-yellow-400 rounded-full transform -translate-x-1.5 group-hover:scale-125 transition-transform duration-300"></div>
                      <h3 className="text-base font-semibold text-white mb-2">
                        {item.title}
                      </h3>
                      <p className="text-base text-gray-400 leading-relaxed">
                        {item.desc}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 lg:px-24 ">
            {array.map((item, index) => (
              <div
                key={index}
                className="text-center bg-slate-900/60 rounded-xl p-4 space-y-4 relative overflow-hidden"
              >
                <Grid size={24} />
                <img
                  src={`/images/users/${item.image}.jpg`}
                  className="w-32 h-32 object-cover rounded-full"
                />

                <h4 className="font-bold text-lg md:text-xl capitalize">
                  {item.name}
                </h4>
                <div className="text-sm md:text-[15px] text-gold !mt-1 leading-tight">
                  {item.title}
                </div>
                {/* <div className="flex gap-3 items-center justify-center">
                  <Link
                    target="_blank"
                    rel="noopener noreferrer"
                    to={item.linkedin}
                    className="hover:bg-gold group rounded-xl"
                  >
                    <Linkedin
                      size={40}
                      className="cursor-pointer text-gold bg-gold/10 p-2 rounded-xl group-hover:text-black"
                    />
                  </Link>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* why choose us */}
      <section className="py-6 md:py-18  overflow-x-hidden">
        <div className="container mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl max-w-xl mx-auto font-bold text-gold mb-5  text-center">
            Why Choose Scan Global Realty
          </h2>
          <p className="mb-16 mx-auto max-w-md text-center text-lg">
            Discover our work and why we do what we do for our clients!
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="bg-slate-900/60 p-8 text-start overflow-hidden rounded-xl relative shadow-md transition-all duration-300 hover:shadow-lg transform hover:-translate-y-2"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <Grid size={30} />
                <div className="flex gap-2 items-center ">
                  <div className="inline-flex items-center justify-center min-w-10 h-10 bg-gold/10 rounded-full mb-3 md:mb-6 ">
                    {benefit.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gold mb-3 md:mb-6">
                    {benefit.title}
                  </h3>
                </div>
                <p className="text-gray-400">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* testimonials */}
      <section className="py-10 md:py-18 overflow-x-hidden">
        <div className="container mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-1 text-center">
            Meet Our Agents
          </h2>
          <p className="text-center max-w-xl text-lg mb-12 mx-auto">
            Our agents are eager and will go above and beyond to make sure they
            find the right investment for you!
          </p>

          <div className="max-w-4xl mx-auto relative">
            <div className="bg-slate-900/60 rounded-xl shadow-lg p-8 md:p-10">
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonials[currentIndex].imageUrl}
                    alt={testimonials[currentIndex].name}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="flex-1">
                  <div className="flex mb-4">
                    {[...Array(testimonials[currentIndex].rating)].map(
                      (_, i) => (
                        <Star
                          key={i}
                          className="w-5 h-5 text-yellow-500 fill-current"
                        />
                      ),
                    )}
                  </div>

                  <blockquote className="text-gray-300 italic mb-6">
                    &quot;{testimonials[currentIndex].quote}&quot;
                  </blockquote>

                  <div>
                    <h4 className="text-lg font-bold ">
                      {testimonials[currentIndex].name}
                    </h4>
                    <p className="text-gray-300">
                      {testimonials[currentIndex].role}
                    </p>
                    <p className="text-gray-400 text-sm">
                      {testimonials[currentIndex].location}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-center mt-8 gap-4">
              <button
                onClick={prevTestimonial}
                className="bg-gold/10 hover:bg-gold/20 text-gold rounded-full p-2 transition-colors"
                aria-label="Previous testimonial"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>

              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-3 h-3 rounded-full ${
                    currentIndex === index ? "bg-gold" : "bg-gray-300/50"
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}

              <button
                onClick={nextTestimonial}
                className="bg-gold/10 hover:bg-gold/20 text-gold rounded-full p-2 transition-colors"
                aria-label="Next testimonial"
              >
                <ChevronRight className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* call to action */}
      <section className="py-16 md:pb-32 text-white overflow-x-hidden">
        <div className="container mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl max-w-xl mx-auto md:text-4xl font-bold mb-6 text-gold">
            Looking for expert real estate guidance?
          </h2>
          <p className="text-base md:text-lg max-w-xl mx-auto mb-10 text-gray-400">
            Let our global team of specialists help you find the perfect
            property solution.
          </p>
          <Link
            to="/realty/contact"
            className="bg-slate-200 px-8 py-2 hover:bg-opacity-85 duration-300 transition-all rounded-full inline-flex gap-2 items-center text-slate-900 font-semibold text-base shadow-lg "
          >
            Get in Touch{" "}
            <ArrowBigDownDashIcon size={20} className="text-slate-900" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default About;
